export default __webpack_public_path__ + "static/media/Pcv1AssemblyH2.5ffdf0ba.png";